import { IconProps } from "./Icon.model";

export function UserSquare({ size = 16, fill = "currentColor" }: IconProps) {
  const fillColor =
    fill === "currentColor" ? "currentColor" : `var(--${fill}-a8)`;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.0576 1.75C14.2479 1.74999 15.9683 1.75012 17.3115 1.93066C18.6882 2.11575 19.7805 2.50313 20.6387 3.36133C21.4969 4.21953 21.8842 5.31182 22.0693 6.68848C22.2499 8.03174 22.25 9.75212 22.25 11.9424V12.0576C22.25 14.2479 22.2499 15.9683 22.0693 17.3115C21.8842 18.6882 21.4969 19.7805 20.6387 20.6387C19.7805 21.4969 18.6882 21.8842 17.3115 22.0693C15.9683 22.2499 14.2479 22.25 12.0576 22.25H11.9424C9.75212 22.25 8.03174 22.2499 6.68848 22.0693C5.31182 21.8842 4.21953 21.4969 3.36133 20.6387C2.50313 19.7805 2.11575 18.6882 1.93066 17.3115C1.75012 15.9683 1.74999 14.2479 1.75 12.0576V11.9424C1.74999 9.75212 1.75012 8.03174 1.93066 6.68848C2.11575 5.31182 2.50313 4.21953 3.36133 3.36133C4.21953 2.50313 5.31182 2.11575 6.68848 1.93066C8.03174 1.75012 9.75213 1.74999 11.9424 1.75H12.0576ZM17.0518 16.4922C14.3844 13.598 9.57101 13.7457 6.95801 16.4824C6.67199 16.782 6.68288 17.2559 6.98242 17.542C7.1277 17.6807 7.31383 17.75 7.5 17.75H16.5C16.6816 17.75 16.8637 17.6844 17.0078 17.5518C17.3123 17.2712 17.3321 16.7968 17.0518 16.4922ZM11.9912 6.25C10.1955 6.25017 8.73828 7.70417 8.73828 9.5C8.73828 11.2958 10.1955 12.7498 11.9912 12.75C13.7871 12.75 15.2451 11.2959 15.2451 9.5C15.2451 7.70407 13.7871 6.25 11.9912 6.25Z"
        fill={fillColor}
      />
    </svg>
  );
}
